import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = {
  key: 0,
  class: "form__submit btn btn--fullscreen",
  type: "submit"
}
const _hoisted_3 = {
  key: 1,
  class: "form__submit btn btn--fullscreen",
  type: "submit"
}

import FormRow from "@/components/forms/FormRow.vue"
import FormInput from "@/components/forms/FormInput.vue"
import ProductBaseForm from "@/components/products/ProductBaseForm.vue"
import {ref} from "vue"
import {useI18n} from "vue3-i18n"
import {notifyError} from "@/notify"
import {Status} from "@/validation"
import {Book} from "@/types/entities"

// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  __name: 'BookForm',
  props: {
    book: {}
  },
  emits: ["formSubmit"],
  setup(__props: any, { emit: __emit }) {

const props = __props

// eslint-disable-next-line
const emit = __emit

const { t } = useI18n()

const book = ref<Book>(props.book ?? {})

const formInputs = ref<any[]>([])
const inputValidationStatuses:any = {}

function addFormInputRef(ref: typeof FormInput) {
    if (!formInputs.value.includes(ref) && ref)
        formInputs.value.push(ref)
}

async function handleValidation(name: string, validationStatus: Status) {
    inputValidationStatuses[name] = validationStatus.valid
}

async function handleSubmit() {
    formInputs.value.forEach((x: typeof FormInput) => x.validateInput())
    if (Object.values(inputValidationStatuses).some(x => x === false)) {
        notifyError(t('global.formErrorNotification'))
        return
    }
    emit("formSubmit", book.value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    class: "form",
    novalidate: "",
    onSubmit: _withModifiers(handleSubmit, ["prevent"]),
    enctype: "multipart/form-data"
  }, [
    _createVNode(ProductBaseForm, {
      product: book.value,
      title: _unref(t)('book.info'),
      "name-fr-label": "book.titleFr",
      "name-en-label": "book.titleEn",
      "description-fr-label": "book.summaryFr",
      "description-en-label": "book.summaryEn",
      onHandleValidation: handleValidation,
      onRegisterFormInputRef: addFormInputRef
    }, {
      "before-prices": _withCtx(() => [
        _createVNode(FormRow, null, {
          default: _withCtx(() => [
            _createVNode(FormInput, {
              modelValue: book.value.author,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((book.value.author) = $event)),
              type: "text",
              name: "author",
              ref: addFormInputRef,
              label: _unref(t)('book.author'),
              onValidated: handleValidation
            }, null, 8, ["modelValue", "label"]),
            _createVNode(FormInput, {
              modelValue: book.value.editor,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((book.value.editor) = $event)),
              type: "text",
              name: "editor",
              ref: addFormInputRef,
              label: _unref(t)('book.editor'),
              onValidated: handleValidation
            }, null, 8, ["modelValue", "label"])
          ]),
          _: 1
        }),
        _createVNode(FormRow, null, {
          default: _withCtx(() => [
            _createVNode(FormInput, {
              modelValue: book.value.isbn,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((book.value.isbn) = $event)),
              type: "text",
              name: "isbn",
              ref: addFormInputRef,
              label: _unref(t)('book.isbn'),
              onValidated: handleValidation
            }, null, 8, ["modelValue", "label"]),
            _createVNode(FormInput, {
              modelValue: book.value.yearOfPublication,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((book.value.yearOfPublication) = $event)),
              type: "number",
              name: "yearOfPublication",
              ref: addFormInputRef,
              label: _unref(t)('book.yearOfPublication'),
              onValidated: handleValidation
            }, null, 8, ["modelValue", "label"])
          ]),
          _: 1
        }),
        _createVNode(FormRow, null, {
          default: _withCtx(() => [
            _createVNode(FormInput, {
              modelValue: book.value.numberOfPages,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((book.value.numberOfPages) = $event)),
              type: "number",
              name: "numberOfPages",
              ref: addFormInputRef,
              label: _unref(t)('book.numberOfPages'),
              onValidated: handleValidation
            }, null, 8, ["modelValue", "label"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["product", "title"]),
    (!props.book)
      ? (_openBlock(), _createElementBlock("button", _hoisted_2, _toDisplayString(_unref(t)("global.add")), 1))
      : (_openBlock(), _createElementBlock("button", _hoisted_3, _toDisplayString(_unref(t)("global.save")), 1))
  ], 40, _hoisted_1))
}
}

})